module.exports = __webpack_public_path__ + "static/media/test3.662ecde3.jpg";